import { render, staticRenderFns } from "./members-box.vue?vue&type=template&id=1c04641e&"
import script from "./members-box.vue?vue&type=script&lang=js&"
export * from "./members-box.vue?vue&type=script&lang=js&"
import style0 from "./members-box.vue?vue&type=style&index=0&id=1c04641e&prod&lang=scss&"
import style1 from "./members-box.vue?vue&type=style&index=1&id=1c04641e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports